
import Vue from "vue";
import {IModal, ModalType} from "@/services/modal-service";
import AppModalItemIframe from "./ModalItemIframe.vue";

export default Vue.extend({
	props: {
		modal: {
			type: Object as ()=>IModal,
			required: true
		}
	},
	computed: {
		isIframe():boolean{
			return this.modal.type == ModalType.IFRAME;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		}
	},
	components: {
		AppModalItemIframe
	}
});
